import MainLayout from 'layout/MainLayout';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import { ArchitectureProtectedRoute } from './DepartmentProtect';
import ProtectedRoute from './ProtectedRoutes';

const Project = Loadable(lazy(() => import('ui-component/project')));
const ProjectReports = Loadable(lazy(() => import('ui-component/reports/project-reports')));
const ProjectMeetings = Loadable(lazy(() => import('ui-component/meetings/project-meetings')));
const ProjectClaims = Loadable(lazy(() => import('ui-component/claims/project-claims')));
const ProjectCertificates = Loadable(lazy(() => import('ui-component/certificates/project-certificates')));
const ProjectTasksUI = Loadable(lazy(() => import('views/pages/roads/ProjectTask')));
const ArchitectDashboard = Loadable(lazy(() => import('views/pages/architecture')));
const ArchitectProjects = Loadable(lazy(() => import('views/pages/architecture/Project')));
const NewProjectPage = Loadable(lazy(() => import('views/pages/architecture/NewProjectPage')));
const ArchitectProjectDetail = Loadable(lazy(() => import('views/pages/architecture/ArchitectProjectDetail')));
const InspectionsPage = Loadable(lazy(() => import('views/pages/architecture/InspectionsReports')));
const MeetingsPage = Loadable(lazy(() => import('views/pages/architecture/Meetings')));
// const ArchitectProjectDetail = Loadable(lazy(() => import('views/pages/architecture/ArchitectProjectDetail')));
const TeamPage = Loadable(lazy(() => import('views/pages/architecture/Team')));
const MemberProfilePage = Loadable(lazy(() => import('views/pages/architecture/MemberProfilePage')));
const TransfersPage = Loadable(lazy(() => import('views/pages/accounting/Transfers')));
const AccountSettings = Loadable(lazy(() => import('ui-component/account-settings')));
const AuditLogsPage = Loadable(lazy(() => import('views/pages/dashbord/utilities/AuditLog')));
// ==============================|| MAIN ROUTING ||============================== //

const ArchitectureRoutes = {
    path: '/architecture',
    element: (
        <ArchitectureProtectedRoute>
            <MainLayout />
        </ArchitectureProtectedRoute>
    ),
    children: [
        {
            path: '/architecture',
            element: <Navigate to="/architecture/dashboard" replace />
        },
        {
            path: '/architecture/dashboard',
            element: <ArchitectDashboard />
        },
        {
            path: '/architecture/project/:projectId/reports',
            element: <ProjectReports />
        },
        {
            path: '/architecture/project/:projectId/meetings',
            element: <ProjectMeetings />
        },
        {
            path: '/architecture/project/:projectId/claims',
            element: <ProjectClaims />
        },
        {
            path: '/architecture/project/:projectId/certificates',
            element: <ProjectCertificates />
        },
        {
            path: '/architecture/project/:projectId/tasks',
            element: <ProjectTasksUI />
        },
        {
            path: '/architecture/projects',
            element: <ArchitectProjects />
        },
        {
            path: '/architecture/projects/:sectorId/:slug',
            element: <ArchitectProjects />
        },
        {
            path: '/architecture/project/new',
            element: (
                <ProtectedRoute permissions={['projects.update', 'projects.create']}>
                    <NewProjectPage />
                </ProtectedRoute>
            )
        },
        {
            path: '/architecture/project/:id',
            element: <ArchitectProjectDetail />
        },
        {
            path: '/architecture/project/:id/edit',
            element: <Project />
        },
        {
            path: '/architecture/team',
            element: <TeamPage />
        },
        {
            path: '/architecture/team/:id',
            element: <MemberProfilePage />
        },
        {
            path: '/architecture/inspections',
            element: <InspectionsPage />
        },
        {
            path: '/architecture/meetings',
            element: <MeetingsPage />
        },
        {
            path: '/architecture/transfers',
            element: <TransfersPage />
        },
        {
            path: '/architecture/account_settings',
            element: <AccountSettings />
        },
        {
            path: '/architecture/audit-logs',
            element: <AuditLogsPage />
        }
    ]
};

export default ArchitectureRoutes;
